module.exports = __webpack_public_path__ + "img/GT6L.03814bb2.png";